import type { LucideIcon } from "lucide-react";
import {
  LayoutDashboard,
  Users,
  FileText,
  Bell,
  BarChart3,
  MessageSquare,
  TrendingUp,
  Briefcase,
  CreditCard,
  ArrowUpDown,
} from "lucide-react";

export interface PlatformNavItem {
  icon: LucideIcon;
  label: string;
  href: string;
  badge?: "tickets" | "announcements" | null;
}

/** Shared admin / operations navigation */
export const adminOperationsNavItems: PlatformNavItem[] = [
  { icon: LayoutDashboard, label: "Dashboard", href: "/admin", badge: null },
  { icon: Users, label: "Investors", href: "/admin/investors", badge: null },
  { icon: Briefcase, label: "Investments", href: "/admin/investments", badge: null },
  { icon: CreditCard, label: "Withdrawals", href: "/admin/withdrawals", badge: null },
  { icon: BarChart3, label: "Returns Input", href: "/admin/investor-returns", badge: null },
  { icon: ArrowUpDown, label: "Transactions", href: "/admin/transactions", badge: null },
  { icon: MessageSquare, label: "Tickets", href: "/admin/tickets", badge: "tickets" },
  { icon: TrendingUp, label: "NAV & Returns", href: "/admin/nav", badge: null },
  { icon: FileText, label: "Statements", href: "/admin/statements", badge: null },
  { icon: Bell, label: "Announcements", href: "/admin/announcements", badge: "announcements" },
  { icon: BarChart3, label: "Reports", href: "/admin/reports", badge: null },
];
